import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { Inventory } from '../types/inventory';
import { inject } from '@angular/core';
import { InventoryService } from '../services/inventory.service';

export const inventoryResolveFn: ResolveFn<Inventory | null> = async () => {
  const service = inject(InventoryService);
  const router = inject(Router);

  const activeInventory =
    service.value() ?? (await service.loadExisting()) ?? service.restoreDraft();

  if (!activeInventory) {
    return new RedirectCommand(router.createUrlTree(['/mde-inventur/start']));
  }

  return activeInventory;
};
